import React from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import SEDatosProducto from '../SEDatosProducto'

const SEModalEditarProducto = () => {
  return (
    <ModalBase>
      <SEDatosProducto editar={true} />
    </ModalBase>
  )
}

export default SEModalEditarProducto
